<template>
	<svg class="ls-icon ls-icon-contacts" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
			<path d="M16 2v2m1.915 18a6 6 0 0 0-12 0M8 2v2" />
			<circle cx="12" cy="12" r="4" />
			<rect width="18" height="18" x="3" y="4" rx="2" />
		</g>
	</svg>
</template>
